import script from "./GoogleTranslate.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleTranslate.vue?vue&type=script&setup=true&lang=js"

import "./GoogleTranslate.vue?vue&type=style&index=0&id=de528726&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de528726"]])

export default __exports__